import axios from "axios";
import React, { useState, useEffect } from "react";
import {
  Dialog,
  Box,
  Slide,
  makeStyles,
  IconButton,
  CircularProgress,
} from "@material-ui/core";
import GridContainer from "../../components/Grid/GridContainer";
import GridItem from "../../components/Grid/GridItem";
import Card from "../../components/Card/Card";
import CardHeader from "../../components/Card/CardHeader";
import CardBody from "../../components/Card/CardBody";
import CustomInput from "../../components/CustomInput/CustomInput";
import Button from "../../components/CustomButtons/Button.js";
import { UpdateCategorysAPI, baseUrl } from "../../config/api";
import _ from "lodash";
import { FilePicker } from "../../components/common/FilePicker";
import { useSelector } from "react-redux";
import DeleteIcon from "@material-ui/icons/Delete";
import { toast } from "react-toastify"

const useStyles = makeStyles((theme) => ({
  fab: {
    position: "absolute",
    bottom: theme.spacing(2),
    right: theme.spacing(2),
  },
  cardCategoryWhite: {
    "&,& a,& a:hover,& a:focus": {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0",
    },
    "& a,& a:hover,& a:focus": {
      color: "#FFFFFF",
    },
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontSize: "65%",
      fontWeight: "400",
      lineHeight: "1",
    },
  },
  imageSize: {
    maxWidth: 350,
  },
  imageWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginTop: "-30px",
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function CategoryMastersEdit(props) {
  const { open, close, item, fetchData } = props;
  const classes = useStyles();

  const [categoryName, setCategoryName] = useState("");
  const [categoryImage, setCategoryImage] = useState([]);
  const [deleteImage, setDeleteImage] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const authToken = useSelector((state) => state.userReducer.authToken);
  const userInfo = useSelector((state) => state.userReducer.userInfo);

  useEffect(() => {
    if (item) {
      setCategoryName(item.name || "");
      setDeleteImage(item.categoryImage === "null" || !item.categoryImage);
      setCategoryImage([]);
    }
  }, [item]);
  async function _onSave() {
    if (categoryName.trim() === "" || (deleteImage && categoryImage.length === 0)) {
      toast.error("Please fill all the fields", {
        position: "top-center",
        autoClose: 1500,
      });
      return;
    }

    setIsSubmitting(true);
    try {
      const formData = new FormData();
      formData.append("name", categoryName.trim());
      formData.append("entity", userInfo.entity);
      
      if (!_.isEmpty(categoryImage)) {
        formData.append("categoryImage", categoryImage[0].path);
      } else if (deleteImage) {
        formData.append("categoryImage", null);
      }

      await axios.patch(UpdateCategorysAPI(item._id), formData, {
        headers: {
          Authorization: `Bearer ${authToken}`,
          "Content-Type": "multipart/form-data",
        },
      });

      toast.success('Successfully Edited!', {
        position: "top-center",
        autoClose: 1500,
      });
      
      close();
      
      // Reset form
      setCategoryName("");
      setCategoryImage([]);
      setDeleteImage(false);
      
      // Refresh data
      if (fetchData && typeof fetchData === 'function') {
        fetchData();
      }
    } catch (e) {
      toast.error("Something went wrong, Please Contact Admin", {
        position: "top-center",
        autoClose: 1500,
      });
    } finally {
      setIsSubmitting(false);
    }
  }

  function _setCategoryImage(files) {
    setCategoryImage(files);
  }

  return (
    <Dialog open={open} onClose={close} TransitionComponent={Transition}>
      <GridContainer>
        <GridItem xs={12}>
          <Card>
            <CardHeader color="primary">
              <Box
                display={"flex"}
                alignItems={"center"}
                justifyContent={"space-between"}
              >
                <h4 className={classes.cardTitleWhite}>Edit Category</h4>
                <Button 
                  color={"transparent"} 
                  onClick={_onSave}
                  disabled={isSubmitting}
                >
                  {isSubmitting ? <CircularProgress size={24} /> : "Save"}
                </Button>
              </Box>
            </CardHeader>
            <CardBody>
              <GridContainer>
                <GridItem xs={6} sm={6} md={6}>
                  <CustomInput
                    labelText="Category Name*"
                    id="CategoryName"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: categoryName,
                      onChange: (event) => setCategoryName(event.target.value),
                    }}
                  />
                </GridItem>
                <GridItem xs={12}>
                  {/* <Paper style={{ padding: "10px" }}> */}
                  {!deleteImage && (
                    <Box
                      sx={{ display: "flex", justifyContent: "flex-end" }}
                      padding={"10px"}
                    >
                      <IconButton
                        onClick={() => {
                          setDeleteImage(true);
                          setCategoryImage([]);
                        }}
                        style={{
                          padding: 0,
                        }}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </Box>
                  )}
                  {!deleteImage && (
                    <Box className={classes.imageWrapper}>
                      <img
                        src={`${baseUrl}${item.categoryImage}`}
                        className={classes.imageSize}
                      />
                    </Box>
                  )}
                  {deleteImage && (
                    <FilePicker
                      files={categoryImage}
                      buttonLabel={"Upload Category Photo*"}
                      id={"Category Photo"}
                      maxFiles={1}
                      setNewFiles={_setCategoryImage}
                      filetype={".png,.jpg,.jpeg"}
                    />
                  )}
                  {/* </Paper> */}
                </GridItem>
              </GridContainer>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </Dialog>
  );
}
